import { render, staticRenderFns } from "./ToolboxTalk.vue?vue&type=template&id=1bca5bf6&scoped=true"
import script from "./ToolboxTalk.vue?vue&type=script&lang=ts"
export * from "./ToolboxTalk.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bca5bf6",
  null
  
)

export default component.exports